(function () {
  "use strict";

  function selectedValue(picker, position) {
    var field = picker.querySelector('[data-option-name]:nth-of-type(' + position + ')');
    if (!field) {
      var fields = picker.querySelectorAll('[data-option-name]');
      field = fields[position - 1];
    }
    if (!field) return "";
    var checked = field.querySelector('input[type="radio"]:checked');
    var select = field.querySelector("select");
    return String((checked && checked.value) || (select && select.value) || field.dataset.selectedValue || "");
  }

  function serviceCount(scope) {
    return scope.querySelectorAll('[data-rehair-service][data-selected="true"]').length;
  }

  function update(scope) {
    var picker = scope.querySelector("variant-picker");
    var summary = scope.querySelector("[data-rehair-selection-summary]");
    if (picker && summary) {
      summary.querySelectorAll("[data-rehair-summary-option]").forEach(function (node) {
        var position = Number(node.getAttribute("data-rehair-summary-option"));
        var value = selectedValue(picker, position);
        if (value) node.textContent = value;
      });

      var services = summary.querySelector("[data-rehair-summary-services]");
      if (services) {
        var count = serviceCount(scope);
        services.textContent = count ? String(count) : services.dataset.noneSelected;
      }
    }

    var variantScript = picker && picker.querySelector("[data-selected-variant]");
    var stickySelection = document.querySelector("[data-rehair-sticky-selection]");
    if (variantScript && stickySelection) {
      try {
        var variant = JSON.parse(variantScript.textContent);
        if (variant && variant.title) stickySelection.textContent = variant.title;
      } catch (error) {
        // The native picker remains authoritative if variant JSON is temporarily unavailable.
      }
    }
  }

  function init() {
    var scope = document.querySelector("product-info[id^='MainProduct']");
    if (!scope) return;
    var schedule = function () {
      window.requestAnimationFrame(function () { update(scope); });
    };
    scope.addEventListener("change", schedule, true);
    update(scope);
    new MutationObserver(schedule).observe(scope, {
      childList: true,
      subtree: true,
      attributes: true,
      attributeFilter: ["data-selected", "data-selected-value"]
    });
  }

  if (document.readyState === "loading") document.addEventListener("DOMContentLoaded", init);
  else init();
})();
